/* Ixaria — fereastra „Vezi diferențe" (tipurile de material: Practic, Confort, Premium, Lux,
   Special), cu markup-ul din snippets/ixaria-configurator-body.liquid (#material-detail-modal).

   Mutata din assets/ixaria-configurator.js (cerut 2026-10-19): pe pagina produsului acela se
   incarca abia dupa motor (ixaria-cfg-overlay.js, pe fundal), deci butonul „Vezi diferențe" de
   langa „Alege materialul" nu deschidea nimic pana atunci, apoi ~1,6s. Aici nu depinde de
   motor: se incarca odata cu pagina (ixaria-mobile-pdp.liquid) si inaintea configuratorului pe
   pagina lui (ixaria-configurator.liquid). Numele raman globale (openMaterialDetail,
   closeMaterialDetail, matdTo, MATERIAL_DETAIL), cum le cheama configuratorul si pagina.
   Colectiile (ingrijirea) vin din assets/ixaria-collections.js, incarcat inainte. */

/* pozele din IX_CFG.assets (snippets/ixaria-configurator-body.liquid), ca cfg_IXA din configurator */
function ixMatdAsset(p){
  var m = (window.IX_CFG && window.IX_CFG.assets) || {};
  return m[p] || p;
}

/* ── Material detail modal ("Vezi diferențe materiale") -- one swipeable card per category
   of „Alege materialul" (FABRIC_PILLS), photo + description together. Titlul si poza sunt ale
   categoriei; descrierea e cea a categoriei din aplicatia Ixaria (priceCategory.description),
   iar „Caracteristici" vin din subtitlurile placilor din vechiul template si din ghidul de
   materiale Agache. Îngrijirea vine de la o colectie din categorie (collectionSlug). */
var MATERIAL_DETAIL = [
  { key:'practic', label:'Practic', asset:ixMatdAsset('assets/cat-practic.jpg'), collectionSlug:'luna',
    desc:'Materiale simple, cu aspect modern și texturat. Materiale rezistente, fără alte proprietăți speciale.',
    features:['Țesături de bază pentru interior', 'Aspect modern, texturat', 'Fără proprietăți speciale'] },
  { key:'confort', label:'Confort', asset:ixMatdAsset('assets/cat-confort.jpg'), collectionSlug:'enjoylux',
    desc:'Material ușor impermeabil, texturat și mat. Culori moderne și vibrante.',
    features:['Impermeabil', 'Easy Clean', 'Aspect mat, culori moderne și vibrante'] },
  { key:'premium', label:'Premium', asset:ixMatdAsset('assets/cat-premium.jpg'), collectionSlug:'milton',
    desc:'Material impermeabil, modern, rezistent.',
    features:['Impermeabil', 'Rezistent, pentru uz intens', 'Aspect modern'] },
  { key:'lux', label:'Lux', asset:ixMatdAsset('assets/cat-lux.jpg'), collectionSlug:'piano',
    desc:'Material din catifea, 100% impermeabil și easy clean. Se curăță ușor doar cu apă, recomandat inclusiv pentru HoReCa.',
    features:['Catifea', 'Impermeabil', 'Easy Clean, se curăță doar cu apă'] },
  { key:'special', label:'Special', asset:ixMatdAsset('assets/cat-special.jpg'), collectionSlug:'zoya',
    desc:'Material Pet Friendly, impermeabil și easy clean. Rezistent la zgârieturile pisicilor și se curăță foarte ușor. Recomandat inclusiv pentru HoReCa.',
    features:['Pet Friendly, rezistent la zgârieturile pisicilor', 'Impermeabil', 'Easy Clean'] }
];
/* Cardurile tipurilor de material (Neted, Texturat, Catifea, Efect catifea), cu textele lor;
   ascunse de la 2026-10-06 odata cu placile lor (FABRIC_TYPE_PILLS). Puse inapoi in
   MATERIAL_DETAIL, „Vezi diferențe" le arata din nou. */
var MATERIAL_TYPE_DETAIL = [
  { key:'neted', label:'Neted', asset:ixMatdAsset('assets/swatch-neted.jpg'), collectionSlug:'enjoylux',
    desc:'Materiale cu o suprafață fină și o textură discretă, fără relieful pronunțat al unei țesături texturate. Pe canapea, culoarea și forma ies în evidență. Potrivite dacă îți place un aspect simplu și uniform, care poate avea reflexe fine în lumină.',
    features:['Textură fină, cu relief discret', 'Aspect uniform', 'Impermeabil'] },
  { key:'texturat', label:'Texturat', asset:ixMatdAsset('assets/swatch-texturat.jpg'), collectionSlug:'luna',
    desc:'Materiale în care împletirea firelor se vede și se simte la suprafață. Relieful adaugă detaliu canapelei chiar și atunci când alegi o singură culoare. Potrivite dacă îți place aspectul de țesătură și vrei ca textura materialului să iasă în evidență.',
    features:['Împletire vizibilă a firelor', 'Suprafață cu relief', 'Textură pronunțată'] },
  { key:'catifea', label:'Catifea', asset:ixMatdAsset('assets/swatch-catifea.jpg'), collectionSlug:'piano',
    desc:'Material cu o suprafață fină și foarte moale la atingere. Lumina și direcția firelor fac aceeași culoare să pară mai deschisă sau mai închisă, oferind profunzime aspectului canapelei. După atingere, pot apărea urme de nuanță, caracteristice catifelei.',
    features:['Atingere foarte moale', 'Reflexe și variații de nuanță în lumină', 'Impermeabil', 'Curățare ușoară cu apă'] },
  { key:'efect-catifea', label:'Efect de catifea', asset:ixMatdAsset('assets/swatch-efectcatifea.jpg'), collectionSlug:'manila',
    desc:'Materiale cu aspect catifelat și finisaje variate, de la suprafețe vizual uniforme la modele discrete, inspirate de împletirea firelor. Potrivite dacă îți place aspectul catifelei și vrei să alegi între mai multe expresii ale acestuia.',
    features:['Aspect catifelat', 'Finisaj uniform sau cu desen discret', 'Texturi și efecte vizuale variate'] }
];
var matdIdx = 0;
/* Cardurile din „Vezi diferențe" (cate unul pe categorie): textul lor, lista „Caracteristici"
   si îngrijirea unei colectii din categorie. Fereastra unei colectii are acum
   continutul ei (ixCollectionSheetBody, mai jos la openCollectionDetail). */
function matdBodyHtml(m, c){
  return '<div class="matd-body">' +
      '<h2>' + m.label + '</h2>' +
      '<p class="matd-desc">' + m.desc + '</p>' +
      '<div class="matd-feats"><h3>Caracteristici</h3><ul>' +
        m.features.map(function(f){ return '<li>' + f + '</li>'; }).join('') +
      '</ul></div>' +
      '<div class="matd-care"><h3>Îngrijire</h3><p>' + c.care + '</p></div>' +
    '</div>';
}
/* The close button sits on the card itself (over the photo), outside the scrolling part so it
   stays put while a long description scrolls underneath. */
function matdSlideHtml(m){
  var c = (window.IX_COLLECTIONS || {})[m.collectionSlug];
  return '<div class="matd-slide">' +
    '<button type="button" class="matd-close" onclick="closeMaterialDetail()" aria-label="Închide">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#121212" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>' +
    '<div class="matd-scroll">' +
      '<div class="matd-hero" style="background-image:url(\'' + m.asset + '\')"></div>' +
      matdBodyHtml(m, c) +
    '</div>' +
  '</div>';
}
function buildMaterialDetail(){
  document.getElementById('matd-track').innerHTML =
    MATERIAL_DETAIL.map(matdSlideHtml).join('') + '<div class="matd-spacer" aria-hidden="true"></div>';
  document.getElementById('matd-dots').innerHTML = MATERIAL_DETAIL.map(function(_, k){
    return '<button onclick="matdTo(' + k + ')" aria-label="Material ' + (k + 1) + '"></button>';
  }).join('');
}
function matdUpdateDots(){
  Array.prototype.forEach.call(document.getElementById('matd-dots').children, function(b, k){ b.classList.toggle('on', k === matdIdx); });
  Array.prototype.forEach.call(document.querySelectorAll('#matd-track .matd-slide'), function(sl, k){ sl.classList.toggle('is-active', k === matdIdx); });
}
/* Native scroll-snap drives the swipe itself (real momentum/rubber-banding); this just figures
   out which card is nearest-centered, so the dots stay in sync whether the user swiped,
   flicked, or tapped a dot. */
function matdSyncFromScroll(){
  var vp = document.getElementById('matd-viewport');
  var track = document.getElementById('matd-track');
  var center = vp.scrollLeft + vp.clientWidth / 2;
  var best = 0, bestDist = Infinity;
  Array.prototype.forEach.call(track.querySelectorAll('.matd-slide'), function(s, k){
    var dist = Math.abs((s.offsetLeft + s.offsetWidth / 2) - center);
    if (dist < bestDist){ bestDist = dist; best = k; }
  });
  matdIdx = best;
  matdUpdateDots();
}
/* Liniutele de sub carduri urmeaza cardul din mijloc cat timp se trage, nu abia
   dupa ce banda se opreste: pana acum asteptau 80ms fara derulare, iar in timpul
   tragerii si al alunecarii fiecare derulare muta asteptarea mai departe. O data
   pe cadru, ca sa nu se socoteasca de mai multe ori intre doua desenari. */
(function(){
  var vp = document.getElementById('matd-viewport');
  if (!vp) return;
  var queued = false;
  vp.addEventListener('scroll', function(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){
      queued = false;
      matdSyncFromScroll();
    });
  }, { passive: true });
})();
/* Mouse drag between cards. Touch swipes the viewport natively, but a mouse can't grab a
   scroll container, so in a desktop window nothing moved. Snap is off while the track follows
   the pointer; on release a 40px+ drag moves one card over (like a swipe), anything shorter
   springs back. The click that ends a drag is swallowed so it can't hit the close button or
   reach the overlay's tap-outside-to-close. */
(function(){
  var modal = document.getElementById('material-detail-modal');
  var vp = document.getElementById('matd-viewport');
  if (!modal || !vp) return;
  var down = false, dragged = false, startX = 0, startLeft = 0, startIdx = 0, dx = 0;
  modal.addEventListener('pointerdown', function(e){
    dragged = false;
    if (e.pointerType !== 'mouse' || e.button !== 0 || !vp.contains(e.target)) return;
    down = true; dx = 0; startX = e.clientX; startLeft = vp.scrollLeft; startIdx = matdIdx;
  });
  window.addEventListener('pointermove', function(e){
    if (!down) return;
    dx = e.clientX - startX;
    if (!dragged && Math.abs(dx) < 5) return;
    if (!dragged){
      dragged = true;
      vp.classList.add('dragging');
      window.getSelection().removeAllRanges();
    }
    vp.scrollLeft = startLeft - dx;
  });
  window.addEventListener('pointerup', function(){
    if (!down) return;
    down = false;
    if (!dragged) return;
    matdTo(Math.abs(dx) < 40 ? startIdx : startIdx + (dx < 0 ? 1 : -1));
    /* re-enabling snap mid-animation would cut the smooth scroll short */
    setTimeout(function(){ vp.classList.remove('dragging'); }, 400);
  });
  modal.addEventListener('click', function(e){
    if (!dragged) return;
    dragged = false;
    e.stopPropagation();
    e.preventDefault();
  }, true);
  /* A tap on a peeking neighbour card brings it to the centre (its close button still closes). */
  modal.addEventListener('click', function(e){
    if (e.target.closest('.matd-close')) return;
    var slide = e.target.closest('#matd-track .matd-slide:not(.is-active)');
    if (slide) matdTo(Array.prototype.indexOf.call(slide.parentNode.children, slide));
  });
  document.addEventListener('keydown', function(e){
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape') closeMaterialDetail();
    else if (e.key === 'ArrowLeft') matdTo(matdIdx - 1);
    else if (e.key === 'ArrowRight') matdTo(matdIdx + 1);
  });
})();
/* Centre `el` inside its own horizontal scroller only. scrollIntoView would also scroll every
   scrollable ancestor -- the configurator panel and the page behind the modal -- which on
   phones left the whole configurator shifted up and stuck after the modal closed. */
function cfgCenterInScroller(scroller, el, instant){
  if (!scroller || !el) return;
  var sr = scroller.getBoundingClientRect(), er = el.getBoundingClientRect();
  var left = scroller.scrollLeft + (er.left - sr.left) - (sr.width - er.width) / 2;
  scroller.scrollTo({ left: Math.max(0, left), behavior: instant ? 'auto' : 'smooth' });
}
function matdTo(i, instant){
  var slides = document.getElementById('matd-track').querySelectorAll('.matd-slide');
  matdIdx = Math.min(slides.length - 1, Math.max(0, i));
  var slide = slides[matdIdx];
  cfgCenterInScroller(document.getElementById('matd-viewport'), slide, instant);
  matdUpdateDots();
}
function openMaterialDetail(key){
  buildMaterialDetail();
  var startIdx = key ? MATERIAL_DETAIL.findIndex(function(m){ return m.key === key; }) : 0;
  document.getElementById('material-detail-modal').classList.add('open');
  matdTo(Math.max(0, startIdx), true);
  Array.prototype.forEach.call(document.querySelectorAll('#matd-track .matd-scroll'), function(s){ s.scrollTop = 0; });
}
function closeMaterialDetail(){
  document.getElementById('material-detail-modal').classList.remove('open');
}
